import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import LoadingPackage from '../../pages/Common/LoadingPackage';
import ExportConfigurationItem from './ExportConfigurationItem';
import { ObsoleteExportConfiguration } from '../../../types/export/exportConfiguration';

interface ExportConfigurationsPaneProps {
  title?: string;
  subtitle?: string;
  configurations: ObsoleteExportConfiguration[];
  loading: boolean;
}

export default function ExportConfigurationsPane({
  title = t(TranslationKey.reporting).singular.upper,
  subtitle = t(TranslationKey.exportConfigurationPaneSubtitle).singular.upper,
  configurations,
  loading,
}: ExportConfigurationsPaneProps) {
  const navigate = useNavigate();

  return (
    <div className={`content-x flex h-full flex-col gap-4 overflow-hidden`}>
      <div className='grid gap-2'>
        <p className='page-title'>{title}</p>
        <p className='subtitle'>{subtitle}</p>
      </div>
      {loading ? (
        <div className='flex flex-grow place-items-center'>
          <LoadingPackage />
        </div>
      ) : (
        <div className='flex flex-grow flex-wrap gap-4'>
          {configurations.map(configuration => (
            <ExportConfigurationItem item={configuration} onClick={() => navigate(`update/${configuration.id}`)} />
          ))}
          <ExportConfigurationItem item={null} onClick={() => navigate('create')} />
        </div>
      )}
    </div>
  );
}
